import { Stack, styled, Typography, useTheme } from '@mui/material';
import { LINK_SUPPORT, PRODUCT_ROADMAP } from 'src/utils/constants/config';
import {
  ICON_NO_MATCH_SEARCH_COMPANY,
  ICON_QUICK_TIP_SEARCH_COMPANY,
  ICON_SUPPORT_NO_DATA_COMPANY,
} from 'src/utils/constants/imagesUrl';

// Components
import { CheckCircle } from 'react-feather';
import IconFeather from 'src/components/common/Icon';
import { StyledWhiteBox } from 'src/features/CompanyDetail/config';
import ImageComponent from 'src/components/common/Image';

// Utilities

const Link = styled('a')(({ theme }) => ({
  color: theme.palette.secondary.main,
  margin: '0px 3px',
  textDecoration: 'underline',
}));

const NoDataSearchPeople = () => {
  const theme = useTheme();
  return (
    <Stack direction="column" alignItems="center" mt={6} spacing={3}>
      <Stack direction="row" width="80%" spacing={6}>
        <ImageComponent imgSrc={ICON_NO_MATCH_SEARCH_COMPANY} height={200} />
        <Stack direction="column" spacing={1} justifyContent="center">
          <Typography variant="h4">Sorry, No Matching Results</Typography>
          <Typography variant="body1" color="text.secondary">
            <br /> We are currently gathering the most recent information for your search. This may take a few moments.
          </Typography>
        </Stack>
      </Stack>
      <StyledWhiteBox display="flex" flexDirection="column" width="70%" border={`1px solid ${theme.palette.divider}`}>
        <Stack direction="column" margin={3} spacing={4}>
          <Stack direction="row" spacing={4}>
            <ImageComponent imgSrc={ICON_QUICK_TIP_SEARCH_COMPANY} height={150} />
            <Stack direction="column" spacing={2}>
              <Typography variant="h4">Quick Tips</Typography>
              <Typography variant="body1" color="text.secondary">
                We are actively retrieving the most up-to-date information for your search. This process may take a
                moment. If the page remains empty, please try refreshing it after a few moments. If the information
                you're looking for is still not available, data to enhance our database.
              </Typography>
              <Stack direction="row" spacing={1}>
                <IconFeather icon={<CheckCircle />} muiProps={{ color: 'success' }} />
                <Typography variant="body1" color="text.secondary">
                  Check your search for typos
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1}>
                <IconFeather icon={<CheckCircle />} muiProps={{ color: 'success' }} />
                <Typography variant="body1" color="text.secondary">
                  Use more generic search terms
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1}>
                <IconFeather icon={<CheckCircle />} muiProps={{ color: 'success' }} />
                <Typography variant="body1" color="text.secondary">
                  Try searching with advanced filters
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          <Stack
            direction="column"
            spacing={1}
            padding={2}
            alignItems="flex-start"
            position="relative"
            bgcolor={theme.palette.success.light}
            borderRadius={theme.shape.borderRadius / 2}
          >
            <Typography variant="h6">Need assistance with an issue? </Typography>
            <Typography variant="body1">
              Visit our{' '}
              <Link href={LINK_SUPPORT} target="_blank">
                support
              </Link>{' '}
              platform. You might also like to check out our{' '}
              <Link href={PRODUCT_ROADMAP} target="_blank">
                development roadmap
              </Link>
              .
            </Typography>
            <ImageComponent
              imgSrc={ICON_SUPPORT_NO_DATA_COMPANY}
              width={100}
              style={{ position: 'absolute', top: theme.spacing(-4), right: theme.spacing(2) }}
            />
          </Stack>
        </Stack>
      </StyledWhiteBox>
    </Stack>
  );
};
export default NoDataSearchPeople;
